import getBrandLogo from '../../helpers/getBrandLogo';

const config = {
  logo: 'mdf-logo',
  logoPath: getBrandLogo(),
  logoSize: 44,
  name: 'MDF',
  welcomeText: '',
  fillColor: '',
  registrationLinkTitle: 'auth.haveAccount.text',
  phoneNumber: 800-459-2003,
  email: 'support@mdfix.com',
  poweredByLogo: true,
};

export default config;


// WEBPACK FOOTER //
// ./src/whitelabel/configs/mdf/index.js